export default __webpack_public_path__ + "static/GT-Walsheim-Pro-Regular-2c0f3c9b809b6965c37c7d13096d087b.ttf";